module.exports = __webpack_public_path__ + "static/media/peanut.76852da4.jpg";